import { render, staticRenderFns } from "./PaqServicios.vue?vue&type=template&id=2d16dca7&scoped=true"
import script from "./PaqServicios.vue?vue&type=script&lang=js"
export * from "./PaqServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16dca7",
  null
  
)

export default component.exports